<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <div ref="apiData"></div>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import SwaggerUI from 'swagger-ui'
import { getDefinitionApiEndpoint } from '@/helpers/api'

export default {
  name: 'LmsPage',
  components: {},
  data() {
    return {}
  },
  methods: {
    loadSwagger() {
      SwaggerUI({
        domNode: this.$refs.apiData,
        url: getDefinitionApiEndpoint('teamculture-enterprise-api-lms'),
        supportedSubmitMethods: [],
      })
    },
  },
  watch: {
    '$i18n.locale'() {
      this.loadSwagger()
    },
  },
  mounted() {
    this.loadSwagger()
  },
}
</script>

<style src="./style.scss" lang="scss" scoped></style>
